// Code: ModalContext component
import Modal from "./Modal.tsx";

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  linkHref: string;
};

function ModalContent({ isModalOpen, setIsModalOpen, linkHref }: Props) {
  // Demander la confirmation
  const handleConfirm = () => {
    window.open(linkHref, "_blank");
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleConfirm}
        >
          <h1 className="modal__title">
            Attention ! En cliquant sur ce lien,
            <span> vous quittez notre site.</span>
          </h1>
          <p className="text-page-light text-page-light--blackSmall">
            Le site web que vous avez demandé à consulter peut contenir des
            infomations sur des produits ou des utilisations de produits qui ne
            sont pas validées en France. D'autre part, les mentions légales du
            site www.cartessurtable-vhc.fr ne s'appliqueront plus. Il faudra
            vous référer aux mentions légales du site en question.
          </p>
        </Modal>
      )}
    </>
  );
}

export default ModalContent;
